import { Directive, ElementRef, Input, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[phoneNumberFormat]'
})
export class ConvertPhoneNumberDirective {
  @Input() phoneNumber: string | undefined;
  constructor(private el: ElementRef) { }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.phoneNumber && this.phoneNumber) {
      const cleanValue = this.phoneNumber.replace(/\D/g, '');
      let formattedValue;
      if (cleanValue.length && this.phoneNumber.length) {
        formattedValue = this.formatPhoneNumber(cleanValue);
      } else {
        formattedValue = this.formatPhoneNumber(this.phoneNumber);
      }
      this.el.nativeElement.textContent = formattedValue;
    }
  }
 private formatPhoneNumber(value: string): string {
    if (!value) return '';
    const numericOnly = /^\d+$/;
    if (!numericOnly.test(value)) {
      return value;
    }

    const number = value.length === 10 ? value : value.length === 11
      ? value.slice(1)
      : (value.length === 12 || value.length === 13)
        ? value.slice(2)
        : '';

    const countryCode = value.length === 11 ? value.slice(0, 1)
      : (value.length === 12 || value.length === 13)
        ? value.slice(0, 2)
        : '';

    if (!number) return value;

    const { areaCode, prefix, line } = this.splitNumber(number);
    return countryCode
      ? `+${countryCode} (${areaCode}) ${prefix}-${line}`
      : `(${areaCode}) ${prefix}-${line}`;
  }

  private splitNumber(num: string) {
    return {
      areaCode: num.slice(0, 3),
      prefix: num.slice(3, 6),
      line: num.slice(6)
    };
  }
}
